import React, {useState, useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, Avatar, useMediaQuery,
} from '@mui/material';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import * as CONSTANTS from "../constants"
import { useParams } from "react-router-dom";
import { useTheme } from '@mui/material/styles';

import { redirect_home_if_sign_out } from "../utils/redirect_link";

const UserProfile = () => {  

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection
    const navigate =  useNavigate();

    let {lang} = useParams();

    document.title = `${CONSTANTS.APP_BAR.USER_MENU.PROFILE[lang]} - Wotagei Zone`

    const [username, ] = useState(localStorage.getItem('username'));
    const [email, ] = useState(localStorage.getItem('email'));
    const [drawerOpen, setDrawerOpen] = useState(false);
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // Sign Out Event
    useEffect(() => {
        redirect_home_if_sign_out(navigate);
    }, [navigate]);
    

    return (
        <Box >
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography 
                                xs={12}
                                variant="h5" 
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bolder",
                                }}
                            >
                                {CONSTANTS.APP_BAR.USER_MENU.PROFILE[lang].toUpperCase()}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 2,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    boxShadow: 3,
                                    margin: "auto",
                                    // backgroundColor: "#f9f9f9",
                                }}
    
                            >
                                {/* Left section: User Icon */}
                                <Avatar
                                    children={
                                        <AccountCircleIcon 
                                            style={{width: "100%", height: "100%"}} 
                                        />
                                    }
                                    alt={username}
                                    sx={{
                                    width: 100,
                                    height: 100,
                                    borderRadius: 2,
                                    marginRight: 2,
                                    }}
                                />

                                {/* Right section: Username and Email */}
                                <Box 
                                    sx={{
                                        margin: 2
                                    }}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {username}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                    {email}
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
 
export default UserProfile;